import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MedelyDateTime } from '@medely/date-time-tools';

export const useCancelScreening = (id?: number | null) => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();

  const { mutate: cancelScreeningLegacy, isPending: isLegacyPending } = useMutation(
    () => axios.post(`/v3/professional/cancel_phone_screening`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['GetRecruitersForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['GetProfessionalScreeningsForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['GetCurrentUserForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['currentUser']);
      },
    },
  );

  const { mutate: cancelScreening, isPending } = useMutation(
    () => {
      return axios.patch(`v3/professional/professional_screenings/${id}`, {
        professional_screening: {
          canceled_at: MedelyDateTime.now({ tz: 'system' }).dateTimeString,
        },
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['GetRecruitersForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['GetProfessionalScreeningsForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['GetCurrentUserForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['currentUser']);
      },
    },
  );

  return { cancelScreeningLegacy, isPending: isLegacyPending || isPending, cancelScreening };
};
